import React from 'react'

function Exchanges() {
  return (
    <section id='exchanges'>
      <h2>Exchanges</h2>
    </section>
  )
}

export default Exchanges
